export enum AddonName {
  INSTANT_PAPER = 'InstantPaper'
}
